module.exports = __webpack_public_path__ + "static/media/metamask.c879a582.svg";